import { gql } from '@apollo/client';

export const TeachersQuery = gql`
  query allTeachers(
    $query: String
    $before: String
    $after: String
    $first: Int
    $last: Int
    $course: Decimal
    $minRating: Decimal
    $availability: String
  ) {
    allTeachers(
      query: $query
      before: $before
      after: $after
      first: $first
      last: $last
      course: $course
      minRating: $minRating
      availability: $availability
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          accessToLms
          fullName
          isDismissed
          rating
          availability
          user {
            id
            phone
            email
          }
          courses
        }
      }
    }
  }
`;

export const VerifyTeacherQuery = gql`
  query verifyTeacher(
    $firstName: String!
    $middleName: String
    $lastName: String!
    $phone: String!
    $email: String!
  ) {
    verifyTeacher(
      teacherInput: {
        firstName: $firstName
        middleName: $middleName
        lastName: $lastName
        phone: $phone
        email: $email
      }
    ) {
      code
      customErrors {
        field
        message
        code
      }
      user {
        id
        firstName
        middleName
        lastName
        phone
        email
        roles
      }
      teacher {
        id
        user {
          id
          firstName
          middleName
          lastName
          phone
          email
        }
      }
    }
  }
`;

export const GetTeacherData = gql`
  query getTeacherData($teacherId: ID) {
    teacher(teacherId: $teacherId) {
      employmentTypes {
        __typename
      }
    }
  }
`;

export const GetTeacherTypes = gql`
  query GetTeacherTypes($teacherId: ID!) {
    teacher(teacherId: $teacherId) {
      employmentTypes {
        ... on IndividualEntrepreneurType {
          __typename
          id
          registrationAddress
          accountNumber
          bankTitle
          bic
          inn
        }

        ... on LegalEntityType {
          __typename
          id
          registrationAddress
          accountNumber
          bankTitle
          bic
          tittle
          inn
        }

        ... on SelfEmployedType {
          __typename
          id
          registrationAddress
          accountNumber
          bankTitle
          bic
          nationality {
            id
            title
          }
          passportNumber
          inn
        }

        ... on NaturalPersonType {
          __typename
          id
          registrationAddress
          accountNumber
          bankTitle
          bic
          nationality {
            id
            title
          }
          passportNumber
        }
      }
    }
  }
`;

export const GetEditTeacher = gql`
  query GetEditTeacher($teacherId: ID!) {
    teacher(teacherId: $teacherId) {
      id
      user {
        id
        firstName
        lastName
        middleName
        email
        phone
      }
      accessToLms
      siteDisplay
      employmentTypes {
        ... on IndividualEntrepreneurType {
          __typename
          id
          registrationAddress
          accountNumber
          bankTitle
          bic
          inn
        }

        ... on LegalEntityType {
          __typename
          id
          registrationAddress
          accountNumber
          bankTitle
          bic
          tittle
          inn
        }

        ... on SelfEmployedType {
          __typename
          id
          registrationAddress
          accountNumber
          bankTitle
          bic
          nationality {
            id
            title
          }
          passportNumber
          inn
        }

        ... on NaturalPersonType {
          __typename
          id
          registrationAddress
          accountNumber
          bankTitle
          bic
          nationality {
            id
            title
          }
          passportNumber
        }
      }
    }
  }
`;

/**
 * Spec 0028 A — «занятость» and «может преподавать». Root queries, not fields on
 * TeacherType: nested there the two-query aggregate would fire once per row of
 * `allTeachers`. `loadBand` is a plain lowercase String on the wire.
 */
export const TeacherLoadQuery = gql`
  query ErpTeacherLoad($teacherId: ID!, $horizonDays: Int) {
    teacherLoad(teacherId: $teacherId, horizonDays: $horizonDays) {
      activeGroups
      activeApplications
      nextLessonDate
      lessonsNext30Days
      hoursNext30Days
      hoursPerWeek
      loadBand
      horizonDays
      weeks {
        weekStart
        lessons
        minutes
        groups
      }
      applications {
        applicationId
        title
        groupId
        groupName
        contractedLessons
        scheduledLessons
        unscheduledLessons
        remainingLessons
        lastLessonDate
      }
    }
  }
`;

export const TeacherCandidateGroupsQuery = gql`
  query ErpTeacherCandidateGroups($teacherId: ID!) {
    teacherCandidateGroups(teacherId: $teacherId) {
      groupId
      groupName
      courseId
      courseName
      startDate
      openLessons
      nextOpenDate
    }
  }
`;
